import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getApiData } from "../../utils/APIHelper";
import { ReactComponent as LeftArrowIcon } from "../../assets/svg/LeftArrowIcon.svg";
import {
  Box,
  CircularProgress,
  Tab,
  Tabs,
  Typography,
  Button,
} from "@mui/material";
import { styled } from "@mui/system";
import { statusStyleArray } from "./config";
import tabs from "./config";
import styles from "./styles";
import {
  formattedAmount,
  getImageSrc,
  transformDateFormat,
} from "../../utils/CommonFunction";
import ProjectOverview from "./components/ProjectOverview";
import { toast } from "react-toastify";
import ConfirmModel from "../../components/ConfirmModel";
import Inclusions from "./components/Inclusions";
import CommissionDetails from "./components/CommissionDetails";
import { ReactComponent as NewDesignIcon } from "../../assets/svg/NewDesignIcon.svg";
import { useTokenValidation } from "../../components/hooks/useTokenValidation";
import SecurityPolicyModal from "../../components/SecurityPolicyModal";

const StyledTab = styled(Tab)(({ theme, selected }) => ({
  color: selected ? "#fff !important" : "#949DAA",
  backgroundColor: selected ? "#0d0d0d !important" : "#fff !important",
  border: "1px solid #d7d8d9",
  borderRadius: "10px",
  minHeight: "40px !important",
  fontWeight: 500,
  textTransform: "none",
  marginRight: "10px",
  padding: "4px 16px !important",
  fontFamily: "Inter Tight",
  "&:hover": {
    backgroundColor: selected ? "#0d0d0d" : "",
    color: !selected && "#000",
  },
  "& .MuiTabs-indicator": {
    backgroundColor: "transparent",
  },
}));

const StyledButton = styled(Button)(({ theme }) => ({
  background: "#4D6BF6",
  color: "#ffffff",
  boxShadow: "none",
  border: "none",
  whiteSpace: "nowrap",
  fontSize: "16px",
  fontWeight: "500",
  borderRadius: "10px",
  padding: ".5vh 1vw",
  letterSpacing: "0",
}));

const GreyStyledButton = styled(Button)(({ theme }) => ({
  background: "#fff",
  color: "#0D0D0E",
  boxShadow: "none",
  border: "1px solid #D7D8D9",
  whiteSpace: "nowrap",
  fontSize: "16px",
  fontWeight: "500",
  borderRadius: "10px",
  padding: ".5vh 1vw",
  letterSpacing: "0",
  "&:hover": {
    background: "#fff",
    boxShadow: "none",
    border: "1px solid #0D0D0E",
  },
}));

export const getStatusDisplayText = (text) => {
  if (typeof text !== "string") return text;
  const displayText = text
    .replace(/[-_]/g, " ")
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
  return displayText;
};

export default function NewPackageDetails() {
  const rejectModal = {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "50%",
    height: "50%",
    bgcolor: "background.paper",
    px: 2,
    py: 2,
    overflow: "hidden",
  };

  const [loader, setLoader] = useState(false);
  const [details, setDetails] = useState({});
  const [isApproved, setIsApproved] = useState(false);

  const { id, tab } = useParams();
  const navigate = useNavigate();

  const tabRoutes = ["", "inclusion", "commission"];

  const tabValue = tabRoutes.indexOf(tab || "");

  useEffect(() => {
    getProjectDetails();
  }, [id]);

  async function getProjectDetails() {
    setLoader(true);
    try {
      const response = await getApiData(
        `api/v2/package/${id}`,
        "GET",
        {},
        { "Content-Type": "application/json" },
        true
      );
      if (response) {
        setDetails(response);
        setLoader(false);
      }
    } catch (error) {
      console.log("error:===>>>", error);
      setLoader(false);
      toast.error(error);
    }
  }

  function handleTabChange(event, newValue) {
    const newTabRoute = tabRoutes[newValue]
      ? `/package/details/${id}/${tabRoutes[newValue]}`
      : `/package/details/${id}`;

    navigate(newTabRoute);
  }

  async function handleApproveProject() {
    try {
      const response = await getApiData(
        `api/v2/package/${details?.id}`,
        "PATCH",
        { status: "awaiting-package-pricing", ownerId: details?.owner?.id },
        { "Content-Type": "application/json" },
        true
      );
      toast.success("Package Approved");
      setIsApproved(false);
      getProjectDetails();
    } catch (error) {
      toast.error(error);
      setIsApproved(false);
    }
  }

  function renderTabContent() {
    console.log("tabValue", tabValue);
    switch (tabValue) {
      case 0:
        return <ProjectOverview details={details} />;
      case 1:
        return (
          <Inclusions details={details} getProjectDetails={getProjectDetails} />
        );
      case 2:
        return <CommissionDetails details={details} />;
    }
  }

  // Token validation hook
  const { showSecurityModal, handleSecurityModalClose } = useTokenValidation();

  return loader ? (
    <center style={styles.header}>
      <CircularProgress />
    </center>
  ) : (
    <>
      <div style={styles.container}>
        <header style={{ ...styles.header, ...styles.rowFlex }}>
          <div style={{ ...styles.headerContent, flex: 1 }}>
            <LeftArrowIcon
              onClick={() => navigate("/packages")}
              style={{ cursor: "pointer" }}
            />
            <div style={styles.idText}>
              <span style={styles.idLabel}>Created At:&nbsp;</span>
              {transformDateFormat(details?.createdAt)}
            </div>
            <div style={styles.statusContainer}>
              <div
                style={{
                  ...styles.statusCircle,
                  backgroundColor:
                    statusStyleArray.find(
                      (style) => style.status === details?.status
                    )?.backgroundColor || "transparent",
                }}
              ></div>
              <div style={styles.statusText}>
                {getStatusDisplayText(details?.status)}
              </div>
            </div>
            {/* <div
              style={{
                ...styles.status_pill,
                backgroundColor:
                  statusStyleArray.find(
                    (style) => style.status === details?.status
                  )?.backgroundColor || "transparent",
                color:
                  statusStyleArray.find(
                    (style) => style.status === details?.status
                  )?.color || "black",
              }}
            >
              {getStatusDisplayText(details?.status)}
            </div> */}
          </div>

          <div
            style={{
              ...styles.rowFlex,
              flex: 1,
              justifyContent: "flex-end",
              gap: "10px",
            }}
          >
            <GreyStyledButton
              onClick={() => navigate(`/new-create-package/${details?.id}`)}
            >
              Edit Package
            </GreyStyledButton>
            {details?.status === "awaiting-contractor-confirmation" && (
              <StyledButton
                variant="contained"
                onClick={() => setIsApproved(true)}
              >
                Approve Package
              </StyledButton>
            )}
          </div>
        </header>

        <div style={styles.subContainer}>
          <div style={{ display: "flex" }}>
            <div style={{ ...styles.rowFlex, gap: "15px", flex: "2" }}>
              <Box
                component="img"
                src={getImageSrc(details?.image?.path)}
                alt="Package Icon"
                sx={{
                  width: 90,
                  height: 90,
                  borderRadius: "16px",
                  marginRight: 1,
                }}
              />

              <div style={styles.columnFlex}>
                <div style={{ ...styles.rowFlex, gap: "15px" }}>
                  <p
                    style={{
                      ...styles.rowFlex,
                      ...styles.startDate,
                      gap: "8px",
                    }}
                  >
                    <NewDesignIcon /> {details?.projectType}
                  </p>
                </div>
                <h2 style={styles.projectHeading}>{details?.name}</h2>
                <p style={styles.endDate}>
                  Last Updated At: {transformDateFormat(details?.updatedAt)}
                </p>
              </div>
            </div>

            <div style={{ ...styles.columnFlex, flex: "1" }}>
              <p style={styles.idLabel}>Package Cost</p>
              <p style={styles.price}>{formattedAmount(details?.cost)}</p>
            </div>
          </div>

          <Tabs
            value={tabValue}
            variant="scrollable"
            onChange={handleTabChange}
            sx={{
              marginTop: "3vh",
              "& .MuiTabs-indicator": {
                background: "none",
              },
            }}
          >
            {tabs.map((tab, index) => (
              <StyledTab
                key={tab.id}
                label={tab.title}
                selected={tabValue === index}
                onClick={() =>
                  console.log(`${tab.title} selected:`, tabValue === index)
                }
              />
            ))}
          </Tabs>

          {renderTabContent(details)}
        </div>
      </div>

      <ConfirmModel
        visible={isApproved}
        handleClose={() => setIsApproved(false)}
        confirmation={handleApproveProject}
        message={
          <>
            <p>Are you sure you want to approve this package?</p>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              sx={{ flexWrap: "wrap", flex: 1, marginTop: "1vh" }}
            >
              <Box
                component="img"
                src={getImageSrc(details?.image?.path)}
                alt="Package Icon"
                sx={{
                  width: 45,
                  height: 45,
                  borderRadius: "8px",
                  border: "2px solid white",
                  boxShadow: "0px 4px 2.67px 0px #00000026",
                  marginRight: 1,
                  flexShrink: 0,
                }}
              />
              <Typography
                sx={{
                  display: "-webkit-box",
                  WebkitBoxOrient: "vertical",
                  WebkitLineClamp: 1,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "normal",
                  fontSize: "14px",
                  fontWeight: "400",
                }}
              >
                {details?.name}
              </Typography>
            </Box>
          </>
        }
      />

      {/* Security Policy Modal */}
      <SecurityPolicyModal
        open={showSecurityModal}
        onConfirm={handleSecurityModalClose}
      />
    </>
  );
}
